import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      role="presentation"
      className={cn("animate-pulse rounded-md bg-gray02/50", className)}
      {...props}
    />
  )
}

export { Skeleton }
